export default "__VITE_ASSET__a7186ad1__"